const postToSheet = async (data = {}) => {
    try {
        // Setup the fetch options with the appropriate headers and body
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${process.env.GATSBY_AIR_TABLE_TOKEN}`
            },
            body: JSON.stringify(data)
        }

        const url =
            process.env.GATSBY_AIR_TABLE_URL ||
            'https://api.airtable.com/v0/app8HjTaKO5eMKwQC/Survey%20Result'

        // Execute the POST request to the specified URL
        const response = await fetch(url, options)
        // Check if the request was successful
        if (!response.ok) {
            // Throw an error if the response status is not in the 200-299 range
            throw new Error(`HTTP error! status: ${response.status}`)
        }

        // Parse the JSON response into native JavaScript objects
        return await response.json()
    } catch (error) {
        // Log and rethrow the error for further handling up the call stack
        console.error('Error during data post:', error.message || error)
        throw error
    }
}

export default postToSheet
